const $ = require('jQuery');
import './machineapps_page_loader.css';

export function machineAppsPageLoader(pLength, pUpdateTimeMs = 100) {
  const lContainer = $('<div>').addClass('machineapps_page_loader');
  let lCurrentStep = 0;
  const lOpacityIncrement = 100.0 / pLength;
  const lUpdateOpacity = (pElement, pIdx) => {
    if (pIdx == lCurrentStep) {
      pElement.css({ opacity: '100%' }).addClass('active');
    }
    else {
      const lDistanceFromCurrent = (lCurrentStep >= pIdx) ? (lCurrentStep - pIdx) : (lCurrentStep + (pIdx - lCurrentStep));
      const lOpacityPercent = 100.0 - (lOpacityIncrement * lDistanceFromCurrent);
      pElement.css({ opacity: lOpacityPercent + "%" }).removeClass('active');
    }
  };

  const lElementList = [];
  for (let lIdx = 0; lIdx < pLength; lIdx++) {
    const lCircle = $('<div>').addClass('machineapps_page_loader_circle');
    lCircle.css({
      'transition': 'all ease-in-out ' + pUpdateTimeMs + 'ms',
    });
    lContainer.append(lCircle);
    lElementList.push(lCircle);
  }
  lElementList.forEach(lUpdateOpacity);

  setInterval(() => {
    lCurrentStep = (lCurrentStep + 1) % pLength;
    lElementList.forEach(lUpdateOpacity);
  }, pUpdateTimeMs);

  return lContainer;
}